"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Validator that checks length of string.
 *
 * @author Stepan Mik, JMt
 */

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Checks the length of a given string.
 *
 * @param minLength the minimal length required
 * @param maxLength the maximal length allowed
 */


var StringLengthValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(StringLengthValidator, _Validator_1$Validato);

  function StringLengthValidator(minLength, maxLength) {
    var _this;

    _classCallCheck(this, StringLengthValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StringLengthValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.minLength = minLength;
    _this.maxLength = maxLength;
    return _this;
  }

  _createClass(StringLengthValidator, [{
    key: "validationError",
    value: function validationError(message, length) {
      return new ValidationResult_1.ValidationError(message, length ? length.toString() : '');
    }
  }, {
    key: "doValidate",
    value: function doValidate(value) {
      if (!this.minLength && value.length < StringLengthValidator.defaultMinLength || this.minLength && value.length < this.minLength) {
        return this.validationError(StringLengthValidator.UNDER_MIN_STRING_LENGTH_ERROR, this.minLength);
      }

      if (!this.maxLength && value.length > StringLengthValidator.defaultMaxLength || this.maxLength && value.length > this.maxLength) {
        return this.validationError(StringLengthValidator.OVER_MAX_STRING_LENGTH_ERROR, this.maxLength);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return StringLengthValidator;
}(Validator_1.Validator);

exports.StringLengthValidator = StringLengthValidator;
StringLengthValidator.OVER_MAX_STRING_LENGTH_ERROR = 'OVER_MAX_STRING_LENGTH';
StringLengthValidator.UNDER_MIN_STRING_LENGTH_ERROR = 'UNDER_MIN_STRING_LENGTH';
StringLengthValidator.defaultMinLength = 0;
StringLengthValidator.defaultMaxLength = 10000;